import React from 'react';

import { Card } from './styles';

export interface CardContainerProps {
  /** The children to display */
  children?: React.ReactNode;
}

const CardContainer = ({
  children
}: CardContainerProps): React.ReactElement => {
  return <Card>{children}</Card>;
};

export default CardContainer;
